import { Container } from '../../../GlobalComponents/Container';
import { QueryResult } from '../../../GlobalComponents/QueryResult';
import { Title } from '../../../GlobalComponents/Title';
import { useAppSelector } from '../../../reduxstore/hooks';
import { useGetOrderHistoryQuery } from '../../api';
import OrderCard from './containers/OrderCard';

const Orders = (): JSX.Element => {
	const userId = useAppSelector(state => state.authReducer.id);
	const { data, error, isLoading } = useGetOrderHistoryQuery(userId);

	interface IOrderItems {
		item: {
			item_id: number;
			product: {
				name: string;
				product_id: string;
			};
		};
	}

	return (
		<Container>
			<Title className="d-none d-lg-block">Online Orders</Title>

			<QueryResult data={data} error={error} loading={isLoading}>
				{data?.data?.order_history.map(
					(order: {
						order_id: string;
						total: number;
						created: string;
						store_id: string;
						orderitems: Array<IOrderItems>;
						order_status: string;
					}) => (
						<OrderCard
							key={order?.order_id}
							orderNumber={order?.order_id}
							total={order?.total}
							date={order.created}
							storeId={order?.store_id}
							orderItems={order?.orderitems}
							status={order?.order_status}
						></OrderCard>
					)
				)}
			</QueryResult>
		</Container>
	);
};

export default Orders;
